/**
 * @license
 * Copyright (c) 2018 Crius Authors. All rights reserved.
 */

import "@polymer/polymer/polymer-element.js";

const $_documentContainer = document.createElement("template");
$_documentContainer.innerHTML = `
<dom-module id="cs-age-gate-shared-styles">
	<template>
		<custom-style>
        <style>
        .cspl-media__age-gate-cover {
            align-items: center;
            display: flex;
            height: 100%;
            justify-content: center;
            left: 0;
            position: absolute;
            top: 0;
            width: 100%;
            z-index: 1
        }

        .cspl-media__age-gate-cover__icon {
            cursor: pointer;
            fill: var(--cs-theme-agegate-cover-icon);
            height: 50px;
            transition: all var(--cs-interface-expansion);
            width: 50px
        }

        .cspl-media__age-gate-cover__icon:hover {
            fill: var(--cs-theme-agegate-cover-icon-hover);
            transform: scale(1.1)
        }
    </style>
			<custom-style>
			</template>
		</dom-module>`;

document.head.appendChild($_documentContainer.content);
